var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCwInfoMultiLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#6A097D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16877_71)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96484 18.1914C9.96484 17.0664 9.96484 15.9414 9.96484 14.8164C13.7617 14.8164 17.5586 14.8164 21.3555 14.8164C21.3555 13.7383 21.3555 12.6602 21.3555 11.582C22.4805 11.582 23.6055 11.582 24.7305 11.582C24.7305 12.6602 24.7305 13.7383 24.7305 14.8164C28.5508 14.8164 32.3711 14.8164 36.1914 14.8164C36.1914 15.9414 36.1914 17.0664 36.1914 18.1914C34.5742 18.1914 32.957 18.1914 31.3398 18.1914C30.1126 22.2298 28.097 25.804 25.293 28.9141C26.7099 30.2489 28.0927 31.62 29.4414 33.0273C29.0243 34.1027 28.6142 35.1809 28.2109 36.2617C28.1605 36.3286 28.1019 36.3403 28.0352 36.2969C26.3818 34.6318 24.7178 32.9795 23.043 31.3398C20.3224 34.0488 17.5919 36.7441 14.8516 39.4258C14.0576 38.7022 13.2842 37.9522 12.5312 37.1758C15.2373 34.3877 17.9912 31.6221 20.793 28.8789C18.8258 26.6345 17.2086 24.1501 15.9414 21.4258C17.0664 21.3321 18.1914 21.3321 19.3164 21.4258C20.3276 23.4022 21.5815 25.2069 23.0781 26.8398C25.3056 24.2973 27.0048 21.4261 28.1758 18.2266C22.1055 18.1914 16.0352 18.1797 9.96484 18.1914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.977,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9648 44.1367C45.9648 44.207 45.9648 44.2773 45.9648 44.3477C44.863 44.3594 43.7615 44.3477 42.6602 44.3125C42.0442 42.7109 41.4348 41.1055 40.832 39.4961C38.2539 39.4024 35.6758 39.4024 33.0977 39.4961C32.4949 41.1055 31.8855 42.7109 31.2695 44.3125C30.1682 44.3477 29.0666 44.3594 27.9648 44.3477C30.3692 37.8264 32.795 31.3107 35.2422 24.8008C35.8 24.7082 36.3742 24.6613 36.9648 24.6602C37.5555 24.6613 38.1296 24.7082 38.6875 24.8008C41.0946 31.2612 43.5204 37.7066 45.9648 44.1367ZM36.8945 29.2305C36.9646 29.2284 37.0115 29.2635 37.0352 29.3359C37.8601 31.5947 38.7038 33.8447 39.5664 36.0859C37.832 36.1328 36.0977 36.1328 34.3633 36.0859C35.2558 33.8184 36.0996 31.5333 36.8945 29.2305Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16877_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCwInfoMultiLanguage);
export default __webpack_public_path__ + "static/media/cw-info-multi-language.eaed18bd7b527e419fbe20982e2a93f8.svg";
export { ForwardRef as ReactComponent };